// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Margin / Risk Dashboard - extends the Equity page patterns (see Equity.css,
   DESIGN_SYSTEM.md) with risk-focused gauges and a historical trend chart. */

.margin-account-block {
  margin-bottom: 2rem;
}

.margin-account-header {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.margin-account-updated {
  font-weight: 400;
  font-size: 0.8125rem;
  color: #6b7280;
}

.margin-account-updated.stale {
  color: #b91c1c;
}

/* --- "What matters here" explainer (top of page) --- */

.margin-explainer-bar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
  color: #374151;
}

.margin-explainer-bar strong {
  color: #1a1a1a;
}

/* --- Risk overview row: gauge + two bars side by side --- */

.margin-risk-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;
}

@media (max-width: 1300px) {
  .margin-risk-row {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 640px) {
  .margin-risk-row {
    grid-template-columns: 1fr;
  }
}

.margin-risk-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  padding: 1rem;
}

.margin-risk-card-title {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* --- Gauge --- */

.margin-gauge-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.25rem;
}

.margin-gauge-sub {
  font-size: 0.72rem;
  color: #6b7280;
  margin-top: 0.125rem;
  text-align: center;
  max-width: 180px;
}

/* --- Key stats (left column of the risk row) --- */

.margin-key-stats {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  justify-content: center;
  height: 100%;
}

.margin-key-stat {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #f3f4f6;
}

.margin-key-stat:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.margin-key-stat-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  display: flex;
  align-items: center;
}

.margin-key-stat-value {
  font-size: 1.0625rem;
  font-weight: 700;
  color: #1a1a1a;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.margin-key-stat.primary .margin-key-stat-value {
  font-size: 1.375rem;
  color: #1a1a1a;
}

.margin-key-stat.primary .margin-key-stat-label {
  font-weight: 600;
  color: #374151;
}

/* --- Refresh Now button + toast --- */

.margin-refresh-btn {
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.375rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
}

.margin-refresh-btn:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #9ca3af;
}

.margin-refresh-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.margin-refresh-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid #d1d5db;
  border-top-color: #4f46e5;
  border-radius: 50%;
  animation: margin-spin 0.7s linear infinite;
}

@keyframes margin-spin {
  to { transform: rotate(360deg); }
}

.margin-toast {
  position: fixed;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  max-width: 90vw;
}

.margin-toast.ok {
  background: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.margin-toast.error {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* --- Utilization / leverage bars --- */

.margin-bar-block {
  margin-bottom: 1.25rem;
}

.margin-bar-block:last-child {
  margin-bottom: 0;
}

.margin-bar-label-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 0.375rem;
  font-size: 0.8125rem;
}

.margin-bar-label {
  color: #374151;
  font-weight: 500;
  display: flex;
  align-items: center;
}

.margin-bar-value {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.margin-bar-value.green { color: #059669; }
.margin-bar-value.orange { color: #d97706; }
.margin-bar-value.red { color: #dc2626; }

.margin-bar-track {
  position: relative;
  height: 10px;
  border-radius: 5px;
  background: #f3f4f6;
  overflow: visible;
}

.margin-bar-zones {
  position: absolute;
  inset: 0;
  border-radius: 5px;
  overflow: hidden;
  display: flex;
}

.margin-bar-zone {
  height: 100%;
}

.margin-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 5px;
  background: #1a1a1a;
  opacity: 0.28;
  transition: width 0.3s ease;
}

.margin-bar-marker {
  position: absolute;
  top: -3px;
  width: 2px;
  height: 16px;
  background: #1a1a1a;
  transform: translateX(-1px);
}

.margin-bar-status {
  font-size: 0.72rem;
  color: #6b7280;
  margin-top: 0.375rem;
}

/* --- Regrouped metric cards --- */

.margin-group-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 1rem 0 0.5rem;
}

/* --- History chart --- */

.margin-history-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  padding: 1rem;
  margin-top: 1rem;
}

.margin-history-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.margin-history-note {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 0.5rem;
}

/* --- Info popover (small, per-metric) --- */

.margin-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 0.3rem;
  vertical-align: middle;
  flex-shrink: 0;
}

.margin-info-popover {
  position: absolute;
  z-index: 1000;
  width: 300px;
  max-width: 80vw;
  background: #ffffff;
  color: #1a1a1a;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 0.875rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
}

/* --- "What matters" modal (general explanation, bigger) --- */

.margin-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.margin-modal {
  background: #ffffff;
  border-radius: 10px;
  max-width: 560px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
}

.margin-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e5e7eb;
}

.margin-modal-header h2 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.margin-modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  padding: 0.25rem;
}

.margin-modal-content {
  padding: 1.25rem;
  font-size: 0.875rem;
  color: #374151;
  line-height: 1.6;
}

.margin-modal-content p {
  margin: 0 0 0.875rem;
}

.margin-modal-content p:last-child {
  margin-bottom: 0;
}

.margin-modal-content strong {
  color: #1a1a1a;
}
`, "",{"version":3,"sources":["webpack://./src/Margin.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,wCAAwC;;AAExC;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA,0BAA0B,cAAc,EAAE;AAC1C,2BAA2B,cAAc,EAAE;AAC3C,wBAAwB,cAAc,EAAE;;AAExC;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA,mCAAmC;;AAEnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,0BAA0B;;AAE1B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6CAA6C;;AAE7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+DAA+D;;AAE/D;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Margin / Risk Dashboard - extends the Equity page patterns (see Equity.css,\n   DESIGN_SYSTEM.md) with risk-focused gauges and a historical trend chart. */\n\n.margin-account-block {\n  margin-bottom: 2rem;\n}\n\n.margin-account-header {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.margin-account-updated {\n  font-weight: 400;\n  font-size: 0.8125rem;\n  color: #6b7280;\n}\n\n.margin-account-updated.stale {\n  color: #b91c1c;\n}\n\n/* --- \"What matters here\" explainer (top of page) --- */\n\n.margin-explainer-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  margin-bottom: 1.5rem;\n  font-size: 0.875rem;\n  color: #374151;\n}\n\n.margin-explainer-bar strong {\n  color: #1a1a1a;\n}\n\n/* --- Risk overview row: gauge + two bars side by side --- */\n\n.margin-risk-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 1300px) {\n  .margin-risk-row {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .margin-risk-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.margin-risk-card {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  padding: 1rem;\n}\n\n.margin-risk-card-title {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* --- Gauge --- */\n\n.margin-gauge-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-top: 0.25rem;\n}\n\n.margin-gauge-sub {\n  font-size: 0.72rem;\n  color: #6b7280;\n  margin-top: 0.125rem;\n  text-align: center;\n  max-width: 180px;\n}\n\n/* --- Key stats (left column of the risk row) --- */\n\n.margin-key-stats {\n  display: flex;\n  flex-direction: column;\n  gap: 0.625rem;\n  justify-content: center;\n  height: 100%;\n}\n\n.margin-key-stat {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding-bottom: 0.625rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.margin-key-stat:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.margin-key-stat-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #6b7280;\n  display: flex;\n  align-items: center;\n}\n\n.margin-key-stat-value {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n\n.margin-key-stat.primary .margin-key-stat-value {\n  font-size: 1.375rem;\n  color: #1a1a1a;\n}\n\n.margin-key-stat.primary .margin-key-stat-label {\n  font-weight: 600;\n  color: #374151;\n}\n\n/* --- Refresh Now button + toast --- */\n\n.margin-refresh-btn {\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.margin-refresh-btn:hover:not(:disabled) {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.margin-refresh-btn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.margin-refresh-spinner {\n  width: 12px;\n  height: 12px;\n  border: 2px solid #d1d5db;\n  border-top-color: #4f46e5;\n  border-radius: 50%;\n  animation: margin-spin 0.7s linear infinite;\n}\n\n@keyframes margin-spin {\n  to { transform: rotate(360deg); }\n}\n\n.margin-toast {\n  position: fixed;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3000;\n  padding: 0.75rem 1.25rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  max-width: 90vw;\n}\n\n.margin-toast.ok {\n  background: #ecfdf5;\n  color: #065f46;\n  border: 1px solid #a7f3d0;\n}\n\n.margin-toast.error {\n  background: #fef2f2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n/* --- Utilization / leverage bars --- */\n\n.margin-bar-block {\n  margin-bottom: 1.25rem;\n}\n\n.margin-bar-block:last-child {\n  margin-bottom: 0;\n}\n\n.margin-bar-label-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 0.375rem;\n  font-size: 0.8125rem;\n}\n\n.margin-bar-label {\n  color: #374151;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n}\n\n.margin-bar-value {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.margin-bar-value.green { color: #059669; }\n.margin-bar-value.orange { color: #d97706; }\n.margin-bar-value.red { color: #dc2626; }\n\n.margin-bar-track {\n  position: relative;\n  height: 10px;\n  border-radius: 5px;\n  background: #f3f4f6;\n  overflow: visible;\n}\n\n.margin-bar-zones {\n  position: absolute;\n  inset: 0;\n  border-radius: 5px;\n  overflow: hidden;\n  display: flex;\n}\n\n.margin-bar-zone {\n  height: 100%;\n}\n\n.margin-bar-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-radius: 5px;\n  background: #1a1a1a;\n  opacity: 0.28;\n  transition: width 0.3s ease;\n}\n\n.margin-bar-marker {\n  position: absolute;\n  top: -3px;\n  width: 2px;\n  height: 16px;\n  background: #1a1a1a;\n  transform: translateX(-1px);\n}\n\n.margin-bar-status {\n  font-size: 0.72rem;\n  color: #6b7280;\n  margin-top: 0.375rem;\n}\n\n/* --- Regrouped metric cards --- */\n\n.margin-group-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 1rem 0 0.5rem;\n}\n\n/* --- History chart --- */\n\n.margin-history-card {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.margin-history-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.margin-history-note {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  margin-top: 0.5rem;\n}\n\n/* --- Info popover (small, per-metric) --- */\n\n.margin-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 0.3rem;\n  vertical-align: middle;\n  flex-shrink: 0;\n}\n\n.margin-info-popover {\n  position: absolute;\n  z-index: 1000;\n  width: 300px;\n  max-width: 80vw;\n  background: #ffffff;\n  color: #1a1a1a;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  padding: 0.875rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n/* --- \"What matters\" modal (general explanation, bigger) --- */\n\n.margin-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.margin-modal {\n  background: #ffffff;\n  border-radius: 10px;\n  max-width: 560px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);\n}\n\n.margin-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.margin-modal-header h2 {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.margin-modal-close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0.25rem;\n}\n\n.margin-modal-content {\n  padding: 1.25rem;\n  font-size: 0.875rem;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.margin-modal-content p {\n  margin: 0 0 0.875rem;\n}\n\n.margin-modal-content p:last-child {\n  margin-bottom: 0;\n}\n\n.margin-modal-content strong {\n  color: #1a1a1a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
